import { Toast } from '@10d/tend-ui/primitives/Toast';
import { createAppSlice } from 'creators';

import { get } from 'api/requests';

import { IParamsReq } from 'types';
import { IAnalyticsContractor } from 'features/Analytics/AnalyticsContractor/types';

import { downloadFileByGet } from 'helpers';

interface IAnalyticsContractorStore {
  data: IAnalyticsContractor | null;
  loading: boolean;
  loadExcelDownload: boolean;
  requestId: string | undefined;
}

const initialState: IAnalyticsContractorStore = {
  loading: false,
  loadExcelDownload: false,
  data: null,
  requestId: undefined,
};

export const analyticsContractorSlice = createAppSlice({
  name: 'analyticsContractorSlice',
  initialState,
  reducers: create => ({
    //
    // reset
    //
    reset: create.reducer(() => initialState),
    //
    // getAnalyticsContractor
    //
    getAnalyticsContractor: create.asyncThunk(
      async (params: IParamsReq, thinkApi) => {
        try {
          const { data } = await get<IAnalyticsContractor>(
            '/api/analytics/transfer-to-settlement/',
            params,
          );
          return data;
        } catch (error) {
          return thinkApi.rejectWithValue(error);
        }
      },
      // Обработка состояний запроса getAnalyticsContractor
      {
        pending: (state, { meta }) => {
          return { ...state, requestId: meta.requestId, loading: true };
        },
        rejected: (state, { meta }) => {
          if (state.requestId === meta.requestId) {
            state.loading = false;
          }
        },
        fulfilled: (state, { payload }) => {
          state.loading = false;
          state.requestId = undefined;

          if (payload) {
            state.data = payload;
          }
        },
      },
    ),
    //
    // getDownloadExcel
    //
    getDownloadExcel: create.asyncThunk(
      async (search: IParamsReq, thinkApi) => {
        try {
          await downloadFileByGet({
            url: '/api/analytics/transfer-to-settlement-excel/',
            params: search,
          });
        } catch (error) {
          return thinkApi.rejectWithValue(error);
        }
      },
      // Обработка состояний запроса getDownloadExcel
      {
        pending: (state, { meta }) => {
          Toast.loading({
            message: 'Происходит подготовка файла',
          });
          return { ...state, requestId: meta.requestId, loadExcelDownload: true };
        },
        rejected: (state, { meta }) => {
          if (state.requestId === meta.requestId) {
            state.loadExcelDownload = false;
          }
        },
        fulfilled: state => {
          state.loadExcelDownload = false;
          state.requestId = undefined;
        },
      },
    ),
  }),
});

export const {
  reset: setReset,
  getDownloadExcel,
  getAnalyticsContractor,
} = analyticsContractorSlice.actions;
